
export default {
  props: {},
  data () {
    return {
      boaPartners: [],
      selectedBoaOffers: [],
      perPage: 9,
      numOffersDisplayed: 9,
      loading: false,
      noOffersAvailable: false,
    };
  },
  computed: {
    selectedBoaOffersProxy: {
      get () {
        return this.selectedBoaOffers;
      },
      set (selectedBoaOffers) {
        if (!selectedBoaOffers.every(partner => partner?.acf?.partner_offers)) {
          return (this.selectedBoaOffers = [...selectedBoaOffers]);
        }
        const boaPartnersWithOffersAtSameObjectLevel = [];
        const currentDate = new Date();
        for (const partner of [...selectedBoaOffers]) {
          if (partner?.acf?.partner_offers) {
            for (const offer of partner.acf.partner_offers) {
              const partnerOffer = {
                ...offer,
                partner,
              };
              boaPartnersWithOffersAtSameObjectLevel.push(partnerOffer);
            }
          }
        }
        this.selectedBoaOffers = [...boaPartnersWithOffersAtSameObjectLevel].filter(offer =>
          new Date(offer.offer_start_date) < currentDate && new Date(offer.offer_end_date) > currentDate,
        );
      },
    },
    totalOffers () {
      return this.shuffledOffers.length;
    },
    outputOffers () {
      return this.shuffledOffers.slice(0, this.numOffersDisplayed);
    },
    shuffledOffers () {
      const clonedOffers = [...this.selectedBoaOffersProxy];
      for (let i = clonedOffers.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const temp = clonedOffers[i];
        clonedOffers[i] = clonedOffers[j];
        clonedOffers[j] = temp;
      }
      return clonedOffers;
    },
  },
  created () {
    this.$nextTick(async () => {
      const boaPartners = await this.getPartners();
      const boaPartnersWithValidOffers = [...boaPartners].filter(
        partner => partner.acf.partner_offers.length,
      );
      this.boaPartners = [...boaPartnersWithValidOffers];
      this.selectedBoaOffersProxy = [...boaPartnersWithValidOffers];
    });
  },
  methods: {
    // INTERFACES:
    sortTheOffers (order) {
      this.boaPartnersWithOffers = this.sortValue({
        order,
        target: this.boaPartnersWithOffers,
      });
    },
    filterSelectedBoaOffersByCategory (selectedBoaOffers) {
      this.numOffersDisplayed = this.perPage;
      this.selectedBoaOffersProxy = [...selectedBoaOffers];
    },
    // ABSTRACTION BARRIER:
    async getPartners () {
      this.loading = true;
      const queryParams = {
        fields: `id,title,acf,image,slug,terms`,
        posts: {
          post_type: `boa-affiliates`,
          posts_per_page: 150,
          post_status: `publish`,
          orderby: `date`,
          order: `DESC`,
        },
        options: {
          image_size: `medium_large`,
          taxonomy: `boa_cat`,
        },
      };
      const request = await this.$getPosts(`/posts`, queryParams);

      this.loading = false;

      if (request !== null) {
        return request;
      }
    },
    combineCategories (categories) {
      // return categories.map(category => category.id).join(`, `);
    },
    sortValue ({ order, target }) {
      return [...target].sort((a, b) =>
        order === `asc`
          ? a.offer_start_date.localeCompare(b.offer_start_date)
          : b.offer_start_date.localeCompare(a.offer_start_date),
      );
    },
  },
};
